import styled from 'styled-components'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom:0;
  left: 0;
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: auto;
  background:rgba(0,0,0,.8);
  animation: opacity .2s ease 1;
`

export default Overlay
